import * as actions from "./actions";

const initialState = {
	groupPermission: null,
	items: [],
	loading: {},
	filter: [],
	pages: null,
	count: 0,
	errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_PERMISSIONS_PER_GROUP: {
			return {
				...state,
				loading: { getAll: true }
			};
		}
		case actions.GET_PERMISSIONS_PER_GROUP_SUCCESS: {
			return {
				...state,
				items: payload,
				loading: { getAll: false }
			};
		}
		case actions.GET_PERMISSIONS_PER_GROUP_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { getAll: false }
			};
		}
		case actions.CREATE_GROUP_PERMISSION: {
			return {
				...state,
				loading: { create: true }
			};
		}
		case actions.CREATE_GROUP_PERMISSION_SUCCESS: {
			return {
				...state,
				loading: { create: false }
			};
		}
		case actions.CREATE_GROUP_PERMISSION_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { create: false }
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
